// Generated by CoffeeScript 2.7.0
var Ajax, GlobalID, MoreSettingsPopover;

import Popover from './popover.js';

({Ajax, GlobalID} = Skylark.Libs);

export default MoreSettingsPopover = class MoreSettingsPopover {
  constructor(element) {
    this.element = element;
    if (!this.element.isPresent()) {
      return;
    }
    this.popover = new Popover(this.element, {
      size: 'small',
      type: 'prompt'
    });
    this.messageGID = new GlobalID($currentController.getVars().messageGID);
    this.element.node.proxy('click', '.js_delete_message', () => {
      var confirmVm;
      this.popover.close();
      confirmVm = Skylark.Bridge.newConfirm({
        icon: '<i class="slp-warning-circle-o"></i>',
        title: '删除消息？',
        message: '当前消息及其所有数据都将被删除，此操作不可撤销',
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'danger'
      });
      return confirmVm.$on('ensureClicked', () => {
        return Ajax.delete(`/admin${this.messageGID.toPath()}.json`, {
          success: function() {
            window.location = '/admin/messages';
            return Skylark.Bridge.newAlertify('删除成功', {
              type: 'success'
            });
          },
          error: function() {
            return Skylark.Bridge.newAlertify('删除失败', {
              type: 'error'
            });
          }
        });
      });
    });
  }

};
